import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getFormattedDate, YYYY_MM_DD_FORMAT, changeDateToGivenFormat, getCurrentDate } from '../../../../../../../Utils/DateUtils';
import _ from 'lodash-es';
import Popup from '../../../../../Common/Popup/Popup';
import { CustomDynamicForm } from '../../../../../Common/CustomForm/CustomDynamicForm';
import { getLumpingFaciltyReducer } from '../../../../../../../redux/reducers/reducerSlices/GetLumpingFaciltyReducer';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sortArrByKey } from '../../../../../../Assests/Utility';
import GateCheckReportList from './ListComponent/GateCheckReportList';
import { usePrevious } from '../../../../../Common/CustomHooks/usePrevious';
import DownloadSection from '../../../DownloadSection/DownloadSection';
import ReportsInput from '../Components/ReportsInputs';
import moment from 'moment';
import './GateCheckReport.css'
import DownloadSectionBECustomFeilds from '../../../DownloadSection/DownloadSectionBECustomFeilds';
import { getRemoteConfigSelector } from '../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import { smartScheduleSelector } from '../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { format } from 'date-fns';

const GateCheckReportSection = (props) => {
    const dispatch = useDispatch();
    const { themeSelected } = props;
    const [showModal, setShowModal] = useState(false);
    const lumpingFacilityData = useSelector(getLumpingFaciltyReducer);
    const user = useSelector(getUserSelector);
    const { userType, parentWarehouse, userAccountDetails, } = user;
    const [lumpingFacDataArr, setLumpingFacDataArr] = useState([]);
    const [selectedLumpingFacility, setSelectedLumpingFacility] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [warehouseListState, setWarehouseListState] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentCustomCalendarType, setCurrentCustomCalendarType] = useState('today');
    const [currentCalendarType, setCurrentCalendarType] = useState('');
    const divRef = useRef(null);
    const [editData, setEditData] = useState({});
    const [currentTable, setCurrentTable] = useState(null);
    const [currentTableRef, setCurrentTableRef] = useState(null);
    const [apiParams, setApiParams] = useState([]);
    const previousTable = usePrevious(currentTable);
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const ss = useSelector(smartScheduleSelector);
    const { isDownloadLoading } = ss;
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const [payload, setPayload] = useState({});
    const [startDateState, setStartDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [endDateState, setEndDateState] = useState(changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat))
    const [showDateRange, setShowDateRange] = useState(false);
    const [startTimeState, setStartTimeState] = useState(new Date());
    const [endTimeState, setEndTimeState] = useState(new Date());

    useEffect(() => {
        const container = divRef.current;
        const tables = container.querySelectorAll('table');
        if (tables && tables.length && _.isEqual(currentTable, previousTable)) {
            setCurrentTableRef(container);
            setCurrentTable(tables);
        }
    })

    useEffect(() => {
        if (lumpingFacilityData.data) {
            const { IDLumpingFacility } = parentWarehouse;
            const tempArr = lumpingFacilityData.data.filter(el => el.ID === IDLumpingFacility)
            setLumpingFacDataArr(tempArr);
        }
    }, [lumpingFacilityData.data])

    useEffect(() => {
        setShowModal(true)
        setSelectedLumpingFacility([])
        setWarehouseListState([])
        setLumpingFacDataArr([])
        dispatch({ type: sagaActions.GET_LUMPING_FACILTY_DATA });
        const { userPermission } = AppConstant;
        if (userType === userPermission.usertypes.user) {
            setWarehouseListState([parentWarehouse])
            setParticularFieldValue({ warehouse_id: parentWarehouse.ID, lumping_facility_id: parentWarehouse.IDLumpingFacility });
        }
        dispatch({ type: sagaActions.CLEAR_GATE_CHECK_REPORT_LIST });
    }, [])

    const getLumpingFacilityList = () => {
        return (
            lumpingFacDataArr &&
            lumpingFacDataArr.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Description}
                    </option>
                );
            })
        );
    };

    const getWarehousesList = () => {
        return (
            warehouseListState &&
            warehouseListState.map((data, index) => {
                return (
                    <option key={data.ID} value={data.ID}>
                        {data.Name}
                    </option>
                );
            })
        );
    };

    const getTimePeriodList = () => {
        const timePeriodArr = ['Monthly', 'Weekly', 'Daily', 'Today', 'Custom']
        return (
            timePeriodArr &&
            timePeriodArr.map((data, index) => {
                return (
                    <option key={data} value={data}>
                        {data}
                    </option>
                );
            })
        );
    };

    const getFormFieldData = (data, name) => {
        if (!name || typeof name !== 'string') return;
        if (data === undefined || data === null) return;

        if (name === 'period_id') {
            const periodValue = data?.toUpperCase();

            if (periodValue === 'CUSTOM') {
                setShowDateRange(true);
                setCurrentCalendarType(data);
                setParticularFieldValue(prev => ({
                    ...prev,
                    period_id: data,
                    'custom-date-picker': ''
                }));
                setSelectedDate('');
            } else {
                setShowDateRange(false);
                setCurrentCalendarType(data);

                if (periodValue === 'TODAY') {
                    const currentFormattedDate = changeDateToGivenFormat(
                        getCurrentDate(),
                        AppConstant.commonStrings.MM_DD_YYYY_dateFormat
                    );
                    setParticularFieldValue(prev => ({
                        ...prev,
                        period_id: data,
                        'custom-date-picker': currentFormattedDate
                    }));
                    setSelectedDate(currentFormattedDate);
                } else {
                    setParticularFieldValue(prev => ({
                        ...prev,
                        period_id: data,
                        'custom-date-picker': ''
                    }));
                    setSelectedDate('');
                }
            }

            return;
        }

        if (name === 'start_date') {
            setStartDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_date: data,
                end_date: '' // reset end date when start date changes
            }));
        } else if (name === 'end_date') {
            setEndDateState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_date: data
            }));
        } else if (name === 'custom-date-picker') {
            const formattedDate = changeDateToGivenFormat(
                data,
                AppConstant.commonStrings.MM_DD_YYYY_dateFormat
            );
            setShowDateRange(false);
            setSelectedDate(formattedDate);
            setParticularFieldValue(prev => ({
                ...prev,
                'custom-date-picker': formattedDate
            }));
        } else if (name === 'start_time') {
            setStartTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                start_time: data
            }));
        } else if (name === 'end_time') {
            setEndTimeState(data);
            setParticularFieldValue(prev => ({
                ...prev,
                end_time: data
            }));
        }
    };


    const getSummitedFormData = (data) => {
        if (!data || typeof data !== 'object') {
            return;
        }

        if (!data.start_date) {
            data.start_date = new Date();
        }
        if (!data.end_date) {
            data.end_date = new Date();
        }

       
        const selectedLumper = (_.find(lumpingFacDataArr, { ID: data?.lumping_facility_id }));
        const selectedWarehouse = (_.find(warehouseListState, { ID: data?.warehouse_id }));

        const paramsArr = [
            { "Lumping Facility ": selectedLumper?.Description || '' },
            { "Warehouse": selectedWarehouse?.Name || '' },
            { "Start Date": data.start_date ? moment(data.start_date).format('MM/DD/YYYY') : ""  },
            { "End Date": data.end_date ? moment(data.end_date).format('MM/DD/YYYY')  : ""},
            { "Shift StartTime": data?.start_time ? data?.start_time : 0},
            { "Shit EndTime": data?.end_time ? data?.end_time : 0},
        ];

        const apiParams = {
            "IDLumpingFacility": data?.lumping_facility_id,
            "IDWarehouse": data?.warehouse_id,
            "StartDate": data.start_date ? moment(data.start_date).format('YYYY-MM-DD'): "",
            "EndDate": data.end_date ? moment(data.end_date).format('YYYY-MM-DD'): "",
            "ShiftStartTime": data?.start_time ? data?.start_time : 0,
            "ShitEndTime": data?.end_time ? data?.end_time : 0,
            "pdfHeaderSection":paramsArr
        }
        setPayload(apiParams);

        setApiParams(paramsArr);
        dispatch({ type: sagaActions.GET_GATE_CHECK_REPORT_LIST, payload: apiParams });
        dispatch({ type: sagaActions.INTIATE_LOADER_REPORTS, payload: true });

        setShowModal(false);
    };

    const combineDateAndTime = (date, time, addTimeZone) => {
        if (!date || !time) return null;

        const datePart = moment(date).format('YYYY-MM-DD');

        if (addTimeZone) {
        return `${datePart}T${time}:00Z`;
        } 
        return `${moment(date).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)} ${time}`;
    };



    const TUSDatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button className="customDatePickerInput" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const TUSTimePickerInput = forwardRef(({ value, onClick }, ref) => {
        let dateStr = moment(value).hours() + ':' + moment(value).minutes();
        if (!value.includes('mm')) {
            const getHour = ("0" + moment(value).hour()).slice(-2);
            const getMin = ("0" + moment(value).minutes()).slice(-2);
            dateStr = getHour + ":" + getMin;
        }

        return (
            <button className="customDatePickerInput" onClick={onClick} ref={ref}>
                {dateStr !== 'NaN:NaN' ? dateStr : 'HH:MM'}
            </button>
        )
    });

    const selectedDateValue = () => {
        if (selectedDate) {
            return selectedDate
        } else if (currentCalendarType === 'Today') {
            return changeDateToGivenFormat(getCurrentDate(), AppConstant.commonStrings.MM_DD_YYYY_dateFormat)
        } else {
            return AppConstant.commonStrings.MM_DD_YYYY_dateFormat
        }
    }

    const formFieldList = [
        {
            name: "lumping_facility_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            placeHolder: 'Select Lumping Company',
            title:
                AppConstant.reports.gateCheckReport.selectLumpingFacility,
            formValidation: {
                required: true,
            },
            getSelectData: getLumpingFacilityList,
        },
        {
            name: "warehouse_id",
            type: "select",
            size: "col-sm-6",
            position: 1,
            title:
                AppConstant.reports.gateCheckReport.warehouse,
            formValidation: {
                required: true,
            },
            getSelectData: getWarehousesList,
        },
        {
            size: "col-sm-6 mt-1",
            name: "start_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "start_date",
                calendarType: currentCustomCalendarType,
                selectedDate: startDateState,
                customInput: <TUSDatePickerInput />
            },
            position: 3,
            value: startDateState,
            title:
                AppConstant.reports.gateCheckReport.startDate,
            formValidation: {
                required: true,
            },
            // hideElement: {
            //     isHidden: showDateRange
            // }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_date",
            type: "custom-date-picker",
            customDatePickerConfig: {
                name: "end_date",
                calendarType: currentCustomCalendarType,
                selectedDate: endDateState,
                startDate: startDateState,
                maxDate: startDateState ? moment(startDateState).add(1, 'months').toDate() > moment().toDate() ? new Date() : moment(startDateState).add(1, 'months').toDate() : null,
                minDate: startDateState ? new Date(startDateState) : null,
                customInput: <TUSDatePickerInput />
            },
            position: 3,
            value: endDateState,
            title:
                AppConstant.reports.gateCheckReport.endDate,
            formValidation: {
                required: true,
            },
            // hideElement: {
            //     isHidden: showDateRange
            // }
        },
        {
            size: "col-sm-6 mt-1",
            name: "start_time",
            type: "custom-time-selector", 
            customDatePickerConfig: {
                name: "start_time",
                showTimeSelect: true,
                showTimeSelectOnly: true,
                selectedDate: startTimeState,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={startTimeState} />
            },
            position: 4,
            value: startTimeState ? startTimeState : "",
            title: "Shift Start Time",
            formValidation: {
                required: true,
            },
            // hideElement: {
            //     isHidden: showDateRange
            // }
        },
        {
            size: "col-sm-6 mt-1",
            name: "end_time",
            type: "custom-time-selector",
            customDatePickerConfig: {
                name: "end_time",
                selectedDate: endTimeState,
                showTimeSelect: true,
                showTimeSelectOnly: true,
                timeIntervals: 30,
                timeCaption: "Time",
                customInput: <TUSTimePickerInput value={endTimeState} />
            },
            position: 4,
            value: endTimeState ? endTimeState : "",
            title: "Shift End Time",
            formValidation: {
                required: true,
            },
            // hideElement: {
            //     isHidden: showDateRange
            // }
        }

    ]

    const editClicked = (data) => {
    }

    const closepopup = () => {
        setShowModal(false);
        setStartDateState('')
        setEndDateState('')
    }

    const submitbtnData = {
        show: true,
        text: AppConstant.reports.generateReportButtonTitle,
    };
    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };
    const createForm = () => {
        return (
            <CustomDynamicForm
                formFieldList={formFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                themeSelected={themeSelected}
                getSummitedFormData={getSummitedFormData}
                getFormFieldData={getFormFieldData}
                editFormData={editData}
                setParticularFieldValue={particularFieldValue}
                loading={loading}
            />
        );
    };

    const popupObj = {
        id: "createWarehouseFormPopup1",
        modalLabel: "createWarehouseFormPopup1",
        showClose: true,
        showfooter: true,
        showHeader: true,
        sendDriverNotification: false,
        modalSize: "xl",
        title: AppConstant.reports.gateCheckReport.createReport,
        bodyText: createForm(),
        subText: "",
        keyboard: false,
        backdrop: "static",
        footerBtn: {
            btn1: {
                show: true,
                text: AppConstant.comments.cancelCommentButtonTitle,
            },
            btn2: {
                show: true,
                text: AppConstant.reports.generateReportButtonTitle,
            },
        },
    };

    function showPopup() {
        setStartDateState('')
        setEndDateState('')
        setShowModal(true);
        setApiParams([]);
        setCurrentCalendarType('');
        setSelectedDate('');
        setShowDateRange(false);
        setParticularFieldValue({});
        dispatch({ type: sagaActions.CLEAR_GATE_CHECK_REPORT_LIST });
        setTimeout(() => {
            setParticularFieldValue({ 
                warehouse_id: parentWarehouse.ID, 
                lumping_facility_id: parentWarehouse.IDLumpingFacility,
            });
        }, 100)
    }
    


    const downloadReport = (payload) => {
        dispatch({ type: sagaActions.DOWNLOAD_REPORT_COMMON, payload });
    }

    const downloadData = (type) => {
        let payloadData = {
            subDomain: "gateCheckReport",
            downloadType: type,
            fileName: "GateCheckReport-" + userAccountDetails?.UserName,
            options: payload
        }
        return payloadData
    }

    const columnList = [
        {
            name: "Carrier",
            value: "Carrier"
        },
        {
            name: "Driver Name",
            value: "driverName"
        },
        {
            name: "Truck #",
            value: "tractor",
        },
        {
            name: "Trailer #",
            value: "trailer",
        },
        {
            name: "POs",
            value: "POs"
        },
        {
            name: "Door",
            value: "door"
        },
        {
            name: "Control No",
            value: "Control"
        },
        {
            name: "Scheduled Date",
            value: "scheduledtime",
            "isReportDate":true
        },
        {
            name: "Scheduled Time",
            value: "scheduledtime",
            "isReportTime":true
        },
        {
            name: "Gate In Time",
            value: "checkInTime",
            "isReportDateAndTime":true
        },
        {
            name: "Bills To Driver",
            value: "OutDoorTime",
            "isReportDateAndTime":true
        },
        {
            name: "Gate Out Time",
            value: "gateOutTime",
            "isReportDateAndTime":true
        },
    ]

    return (
        <div className="pt-2">

            <div className='container-fluid d-flex py-2 text-start justify-content-between'>
                <button
                    className={'addButton me-4'}
                    onClick={() => showPopup()}>
                    {
                        AppConstant.reports.gateCheckReport.createReport
                    }
                </button>
                <div className='d-flex align-items-center'>
                    <DownloadSectionBECustomFeilds isSchedulePro={true} downloadData={downloadData} isLoading={isDownloadLoading} isDisabled={isDownloadLoading} columnList={columnList} downloadReport={downloadReport} />

                </div>
            </div>

            <div className="roleListTable mt-1">
                <Popup
                    {...popupObj}
                    showModal={showModal}
                    showfooter={false}
                    closepopup={closepopup}
                    themeSelected={themeSelected}
                />
            </div>
            <div ref={divRef} className='gateCheckReportTable'>
                {
                    (apiParams && apiParams.length) ?
                        <div>
                            <div className="mx-2 container-fluid text-center graphHeading">{AppConstant.reports.gateCheckReport.title}</div>
                            <ReportsInput apiParams={apiParams} />
                            <GateCheckReportList isLoading={loading} />
                        </div>
                        :
                        <div />
                }
            </div>
        </div>
    );
};

export default GateCheckReportSection;